import { get, post } from "../store/apiClient";
import {
  ApplicationResponse,
  CandidateResponse,
} from "../store/slices/application/applicationTypes";
import { formatUrl } from "../utils/urlFormatter";

// Endpoint path
const uploadAddResume = "/application.addResume";
const createAddResponse = "/application.updateApp";
const applicationList = "/application.list";
const applicationDetails = "/{0}/application.appDetail";
const aiInterviewDetails = "/{0}/aiInterview.session";
const startInterviewApi = "/{0}/aiInterview.question/{1}/start";
const submitInterviewApi = "/{0}/aiInterview.question/{1}/submit";
const completeInterviewApi = "/{0}/aiInterview.complete";
const upload_interview_video = "/public/{0}/upload";

const credentialsConfig = {
  withCredentials: true,
  headers: {
    "Content-Type": "multipart/form-data", // Ensures correct handling of file uploads
  },
};

export const uploadResume = async (
  file: File,
  jobId: string,
  base_slug: string,
  app_id: string, // ✅ Added app_id parameter
  email: string,
): Promise<CandidateResponse> => {
  const endpoint = formatUrl(uploadAddResume, []);

  const formData = new FormData();
  formData.append("resume", file);
  formData.append("job_id", jobId);
  formData.append("base_slug", base_slug);
  formData.append("app_id", app_id);
  formData.append("email", email);

  return post<CandidateResponse>(endpoint, formData, credentialsConfig);
};

// Create Application Function
// Create Application Function
export const createApplication = async (payload: {
  job_id: string;
  base_slug: string;
  app_id: string;
  app_email: string;
  name?: string;
  phone?: string;
  location?: string;
  summary?: string;
  education?: any;
  experience?: any;
  links?: string[];
  resume?: string;
  cover_letter?: string;
}): Promise<CandidateResponse> => {
  const endpoint = formatUrl(createAddResponse, []);

  return post<CandidateResponse>(endpoint, payload, { withCredentials: true });
};

export const fetchApplicationDataList =
  async (): Promise<ApplicationResponse> => {
    const endpoint = formatUrl(applicationList, []);
    return get<ApplicationResponse>(endpoint);
  };

export const fetchApplicationDetails = async (
  appId: string,
): Promise<ApplicationResponse> => {
  const endpoint = formatUrl(applicationDetails, [appId]);
  return get<ApplicationResponse>(endpoint);
};

export const fetchAiInterviewDetails = async (
  appId: string,
): Promise<ApplicationResponse> => {
  const endpoint = formatUrl(aiInterviewDetails, [appId]);
  return get<ApplicationResponse>(endpoint);
};

export const startInterview = async (
  appId: string,
  questinNo: string,
): Promise<CandidateResponse> => {
  const endpoint = formatUrl(startInterviewApi, [appId, questinNo]);
  console.log(endpoint);

  return post<CandidateResponse>(endpoint, {}, { withCredentials: true });
};

export const endInterView = async (
  appId: any,
  questionNo: any,
  video: any,
): Promise<CandidateResponse> => {
  const endpoint = formatUrl(submitInterviewApi, [appId, questionNo]);

  // const formData = new FormData();
  // formData.append("video_url", video)
  // ;
  const payload = {
    video_url: video,
  };

  return post<CandidateResponse>(endpoint, payload, { withCredentials: true });
};


export const completeInterView = async (
  appId: any,
): Promise<CandidateResponse> => {
  const endpoint = formatUrl(completeInterviewApi, [appId,]);
 

  return post<CandidateResponse>(endpoint, {}, { withCredentials: true });
};

export const uploadInterViewVideoData = async (
  payload: any,
  folderName: number,
): Promise<any> => {
  console.log("service upload ===> ", payload, folderName);
  const update_base_url = formatUrl(upload_interview_video, [folderName]);
  const formData = new FormData();
  formData.append("file", payload.file);
  return post<any>(update_base_url, formData, {
    ...credentialsConfig,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
